import { StyleSheet } from "react-native";

import type { UiTheme } from "../theme";

// #355: the simulator's styles, one sheet for the section and its blocks.
// No box of its own: the section sits inside a card (Home's hero, a Library
// card), and a card in a card is banned.

/** Below this the two columns stack: a muscle row needs ~320 to read. */
export const SIMULATION_COLUMN_MIN = 320;

export function makeSimulationStyles(theme: UiTheme) {
  const { palette: p, spacing: s, typography: ty } = theme;
  const mono = { fontFamily: ty.fonts.mono, fontVariant: ["tabular-nums" as const] };
  return StyleSheet.create({
    section: { gap: s.s3 },
    head: { minHeight: 44, flexDirection: "row", alignItems: "center", gap: s.s2 },
    headText: { flex: 1, gap: s.s1 },
    titleRow: { flexDirection: "row", flexWrap: "wrap", alignItems: "baseline", gap: s.s2 },
    summary: { color: p.ink, fontSize: ty.sizes.base, fontWeight: "600", lineHeight: ty.sizes.base * 1.35 },
    quiet: { color: p.ink3, fontSize: ty.sizes.sm, lineHeight: ty.sizes.sm * 1.4 },
    note: { color: p.ink2, fontSize: ty.sizes.sm, lineHeight: ty.sizes.sm * 1.4 },
    // Wide: two columns that wrap to one when the card is narrower than both.
    columns: { gap: s.s4 },
    columnsWide: { flexDirection: "row", flexWrap: "wrap", alignItems: "flex-start" },
    column: { gap: s.s4 },
    columnWide: { flexGrow: 1, flexShrink: 1, flexBasis: SIMULATION_COLUMN_MIN },
    block: { gap: s.s1 },
    line: { color: p.ink, fontSize: ty.sizes.sm, lineHeight: ty.sizes.sm * 1.4 },
    pair: { flexDirection: "row", flexWrap: "wrap", alignItems: "baseline", gap: s.s2 },
    pairLabel: { flexShrink: 1, color: p.ink, fontSize: ty.sizes.sm },
    pairValue: { ...mono, marginLeft: "auto", color: p.ink, fontSize: ty.sizes.sm },
    // Muscle rows: the shape is CoverageRowShell's; these are what sits under it.
    rowZone: { color: p.ink2, fontSize: ty.sizes.sm, lineHeight: ty.sizes.sm * 1.4 },
    seeAll: { paddingVertical: s.s2, minHeight: 44, justifyContent: "center" },
    seeAllTxt: { color: p.brandText, fontSize: ty.sizes.base, fontWeight: "600" },
  });
}

export type SimulationStyles = ReturnType<typeof makeSimulationStyles>;
